import { render, staticRenderFns } from "./FormResumen.vue?vue&type=template&id=493c6157&"
import script from "./FormResumen.vue?vue&type=script&lang=js&"
export * from "./FormResumen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports